var Utility = (function () {
    var todayDate = function () {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }

        return yyyy + '-' + mm + '-' + dd;
    };
    var lastMoDate = function () {
        var today = new Date();
        var lastMo = new Date(today.setMonth(today.getMonth() - 1));
        var dd = lastMo.getDate();
        var mm = lastMo.getMonth() + 1;
        var yyyy = lastMo.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
    };
    var nowAddDays = function (days) {
        var today = new Date();
        var result = new Date();
        result.setDate(today.getDate() + days);
        var dd = result.getDate();
        var mm = result.getMonth() + 1;
        var yyyy = result.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
    };
    return {
        todayDate: todayDate,
        lastMoDate: lastMoDate,
        nowAddDays: nowAddDays
    }
})();
export default Utility;